export enum LabelType {
	CORE = 'Core',
	CUSTOM = 'Custom'
}

export enum PanelMode {
	ADD = 'add',
	EDIT = 'edit'
}

export interface LabelValue {
	value: string;
	dashboardVisible?: boolean;
}

export interface Label {
	key: string;
	displayName: string;
	description?: string;
	type: LabelType;
	values: LabelValue[];
}
